/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Les_Start_TitleInputs */

const nl_les_start_title = /** @type {(inputs: Les_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start een les`)
};

/**

* @param {Les_Start_TitleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const les_start_title = /** @type {((inputs?: Les_Start_TitleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Les_Start_TitleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_les_start_title(inputs)
});
export { les_start_title as "les.start.title" }